/* En-tête CLIC (copie klikcamera.com / Symmetry) :
   - <kc-announcement> : défilement des messages du bandeau (si plusieurs).
   - <kc-header> : état « défilé » (en-tête transparent → plein), hauteur réelle (--kc-header-h),
     tiroir de menu téléphone (+ sous-panneau), carte produit du tiroir (images / pastilles). */
(function () {
  if (!customElements.get('kc-announcement')) {
    class KcAnnouncement extends HTMLElement {
      connectedCallback() {
        this.slides = Array.from(this.querySelectorAll('.kc-announcement__slide'));
        if (this.slides.length < 2) return;
        this.index = 0;
        this.querySelector('[data-kc-ann-prev]')?.addEventListener('click', () => this.go(this.index - 1, true));
        this.querySelector('[data-kc-ann-next]')?.addEventListener('click', () => this.go(this.index + 1, true));
        this.addEventListener('mouseenter', () => this.stop());
        this.addEventListener('mouseleave', () => this.start());
        this.start();
      }
      disconnectedCallback() { this.stop(); }
      start() {
        if (this.dataset.autoplay !== 'true') return;
        this.stop();
        this.timer = setInterval(() => this.go(this.index + 1), (parseInt(this.dataset.speed, 10) || 5) * 1000);
      }
      stop() { clearInterval(this.timer); }
      go(i, manual) {
        const n = this.slides.length;
        this.index = (i + n) % n;
        this.slides.forEach((s, k) => s.classList.toggle('is-active', k === this.index));
        if (manual) this.start();
      }
    }
    customElements.define('kc-announcement', KcAnnouncement);
  }

  if (customElements.get('kc-header')) return;

  class KcHeader extends HTMLElement {
    connectedCallback() {
      this.section = this.closest('.kc-section-header') || this.parentElement;
      this.drawer = this.querySelector('.kc-drawer');
      this.burger = this.querySelector('[data-kc-drawer-toggle]');

      this.onScroll = this.onScroll.bind(this);
      window.addEventListener('scroll', this.onScroll, { passive: true });
      this.onScroll();

      // Hauteur réelle de la barre (sert au décalage de l'en-tête transparent et à la position du menu déroulant)
      const bar = this.querySelector('.kc-header__bar');
      if (bar && 'ResizeObserver' in window) {
        this.ro = new ResizeObserver(() => {
          const h = bar.getBoundingClientRect().height;
          if (h) document.documentElement.style.setProperty('--kc-header-h', h + 'px');
        });
        this.ro.observe(bar);
      }

      // Menu ordi : aria-expanded au survol / focus
      this.querySelectorAll('.kc-nav__item--has-children').forEach((item) => {
        const link = item.querySelector('.kc-nav__link');
        const set = (v) => link && link.setAttribute('aria-expanded', v);
        item.addEventListener('mouseenter', () => set('true'));
        item.addEventListener('mouseleave', () => set('false'));
        item.addEventListener('focusin', () => set('true'));
        item.addEventListener('focusout', (e) => { if (!item.contains(e.relatedTarget)) set('false'); });
      });

      // Tiroir téléphone
      if (this.drawer) {
        requestAnimationFrame(() => this.drawer.classList.add('is-ready'));
        this.burger?.addEventListener('click', () => this.openDrawer());
        this.querySelectorAll('[data-kc-drawer-close]').forEach((el) => el.addEventListener('click', (e) => { e.preventDefault(); this.closeDrawer(); }));
        this.querySelector('[data-kc-drawer-back]')?.addEventListener('click', (e) => { e.preventDefault(); this.closeSub(); });
        this.querySelectorAll('[data-kc-drawer-sub]').forEach((el) => el.addEventListener('click', (e) => {
          e.preventDefault();
          this.openSub(el.getAttribute('data-kc-drawer-sub'), el);
        }));
        this.onKey = (e) => { if (e.key === 'Escape' && this.isOpen) this.closeDrawer(); };
        document.addEventListener('keydown', this.onKey);
        this.mq = window.matchMedia('(min-width: 768px)');
        this.onMq = () => { if (this.mq.matches && this.isOpen) this.closeDrawer(); };
        this.mq.addEventListener ? this.mq.addEventListener('change', this.onMq) : this.mq.addListener(this.onMq);
      }

      this.querySelectorAll('[data-kc-dcard]').forEach((card) => this.initCard(card));
    }

    disconnectedCallback() {
      window.removeEventListener('scroll', this.onScroll);
      if (this.onKey) document.removeEventListener('keydown', this.onKey);
      if (this.ro) this.ro.disconnect();
      document.documentElement.classList.remove('kc-drawer-lock');
    }

    onScroll() {
      const scrolled = window.scrollY > 0;
      if (scrolled !== this.scrolled) {
        this.scrolled = scrolled;
        this.section.classList.toggle('kc-scrolled', scrolled);
      }
    }

    get isOpen() { return this.section.classList.contains('kc-nav-open'); }

    openDrawer() {
      this.section.classList.add('kc-nav-open');
      document.documentElement.classList.add('kc-drawer-lock');
      this.drawer.setAttribute('aria-hidden', 'false');
      this.burger?.setAttribute('aria-expanded', 'true');
      setTimeout(() => this.drawer.querySelector('.kc-drawer__close')?.focus({ preventScroll: true }), 50);
    }

    closeDrawer() {
      this.section.classList.remove('kc-nav-open');
      document.documentElement.classList.remove('kc-drawer-lock');
      this.drawer.setAttribute('aria-hidden', 'true');
      this.burger?.setAttribute('aria-expanded', 'false');
      setTimeout(() => this.closeSub(true), 340);
      this.burger?.focus({ preventScroll: true });
    }

    openSub(id, trigger) {
      const sub = this.querySelector('#' + CSS.escape(id));
      if (!sub) return;
      this.drawer.scrollTop = 0;
      sub.classList.add('is-open');
      this.drawer.classList.add('child-open');
      const title = this.drawer.querySelector('[data-kc-drawer-title]');
      if (title) title.textContent = sub.dataset.title || '';
      const back = this.drawer.querySelector('[data-kc-drawer-back]');
      if (back) back.tabIndex = 0;
      this.drawer.querySelectorAll('[data-kc-drawer-sub="' + id + '"]').forEach((el) => el.setAttribute('aria-expanded', 'true'));
      this.currentTrigger = trigger;
    }

    closeSub(silent) {
      this.drawer.querySelectorAll('.kc-drawer__sub.is-open').forEach((s) => s.classList.remove('is-open'));
      this.drawer.classList.remove('child-open');
      const back = this.drawer.querySelector('[data-kc-drawer-back]');
      if (back) back.tabIndex = -1;
      this.drawer.querySelectorAll('[data-kc-drawer-sub]').forEach((el) => el.setAttribute('aria-expanded', 'false'));
      if (!silent && this.currentTrigger) this.currentTrigger.focus({ preventScroll: true });
    }

    initCard(card) {
      const images = Array.from(card.querySelectorAll('.kc-dcard__image[data-media-id]'));
      if (!images.length) return;
      let index = 0;
      const show = (i) => {
        index = (i + images.length) % images.length;
        images.forEach((img, k) => img.classList.toggle('is-active', k === index));
      };
      card.querySelector('[data-kc-dcard-prev]')?.addEventListener('click', () => show(index - 1));
      card.querySelector('[data-kc-dcard-next]')?.addEventListener('click', () => show(index + 1));
      card.querySelectorAll('.kc-dcard__swatch[data-media-id]').forEach((sw) => {
        sw.addEventListener('click', () => {
          const k = images.findIndex((img) => img.dataset.mediaId === sw.dataset.mediaId);
          if (k > -1) show(k);
        });
      });
      // Glisser sur l'image (téléphone)
      const media = card.querySelector('.kc-dcard__media');
      let x0 = null;
      media?.addEventListener('touchstart', (e) => { x0 = e.touches[0].clientX; }, { passive: true });
      media?.addEventListener('touchend', (e) => {
        if (x0 === null) return;
        const dx = e.changedTouches[0].clientX - x0;
        if (Math.abs(dx) > 40) show(index + (dx < 0 ? 1 : -1));
        x0 = null;
      }, { passive: true });
    }
  }
  customElements.define('kc-header', KcHeader);
})();
